import React from 'react'

function Loading() {
 return (
  <div className="loading">
   <h2>Loading...</h2>
  </div>
 )
}

export default Loading
